let bodyLockTimeout = null;

export async function initSwitchNav() {
  const module = await import('../tools/basic-functions.js');
  module.click('.js-open-menu', switchNav);
  module.click('.js-open-user-menu', switchUserNav);
  //	module.click('.navigation', closeNav);
  document.querySelector('.navigation').addEventListener('click', (e) => {
    closeNav(e.target);
  });
  let additionalMenuSwitcher = document.querySelector('.js-open-menu-additional');
  if (additionalMenuSwitcher) {
    let additionalMenu = additionalMenuSwitcher.parentNode.querySelector('.nav-additional-inner');
    document.addEventListener('click', (e) => {
      if (!additionalMenu.contains(e.target) && additionalMenu.classList.contains('active')) {
        additionalMenu.classList.remove('active');
      }
      if (e.target == additionalMenuSwitcher) {
        additionalMenu.classList.add('active');
      }
    });
  }
}

export function initPWA() {
  if (checkPwaInfo()) {
    window.addEventListener('beforeinstallprompt', initPwaPopup);
  }
  if (isIos() && !isInStandaloneMode() && checkPwaInfo()) {
    initIosPwaPopup();
  }
}

/*export function initBanner() {
	if (_CMS_USER_NO_DEP == 0 || _CMS_USER_NO_DEP == 1) {
		document.querySelector('.nav-banner-wrapper').classList.add('no-deposit');
	}
}*/

function checkPwaInfo() {
  let localStorageKey = 'pwa-info';
  let isExpired = true;

  try {
    if (localStorage.hasOwnProperty(localStorageKey)) {
      let obj = JSON.parse(localStorage.getItem(localStorageKey)),
        localStorageObjDate = obj.timestamp,
        now = new Date().getTime().toString();

      if (localStorageObjDate + 168 * 60 * 60 * 1000 < now) {
        isExpired = true;
      } else {
        isExpired = false;
      }
    } else {
      isExpired = true;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    isExpired = true;
  }

  return isExpired;
}

function isIos() {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /iphone/.test(userAgent);
}

const isInStandaloneMode = () => 'standalone' in window.navigator && window.navigator.standalone;

function initPwaPopup(e) {
  e.preventDefault();
  let deferredPrompt = e;
  let prompt = document.querySelector('.pwa-prompt');
  if (!prompt) {
    return false;
  }
  document.body.classList.add('pwa-prompt-open');
  prompt.classList.remove('d-none');

  prompt.querySelector('.install').addEventListener('click', async () => {
    prompt.classList.add('d-none');
    document.body.classList.remove('pwa-prompt-open');
    try {
      await deferredPrompt.prompt();
      await deferredPrompt.userChoice;
      deferredPrompt = null;
    } catch (e) {
      console.error(e);
    }
  });
  prompt.querySelector('.close-btn').addEventListener('click', () => {
    prompt.classList.add('d-none');
    document.body.classList.remove('pwa-prompt-open');
    window.removeEventListener('beforeinstallprompt', initPwaPopup);
    let data = { pwaInfo: false, timestamp: new Date().getTime() };
    localStorage.setItem('pwa-info', JSON.stringify(data));
  });
}

function initIosPwaPopup() {
  let prompt = document.querySelector('.pwa-prompt');
  document.body.classList.add('pwa-prompt-open');
  prompt.classList.remove('d-none');
  prompt.querySelector('.install').addEventListener('click', () => {
    prompt.classList.add('d-none');
    document.body.classList.remove('pwa-prompt-open');
    let data = { pwaInfo: false, timestamp: new Date().getTime() };
    localStorage.setItem('pwa-info', JSON.stringify(data));
    let iosPwaPopup = document.querySelector('.install-pwa-ios-modal');
    iosPwaPopup.classList.add('is-active');
    document.addEventListener('click', (e) => {
      if (
        !iosPwaPopup.querySelector('.message-box').contains(e.target) &&
        iosPwaPopup.classList.contains('is-active') &&
        !prompt.contains(e.target)
      ) {
        iosPwaPopup.classList.remove('is-active');
      }
    });
  });
  prompt.querySelector('.close-btn').addEventListener('click', () => {
    prompt.classList.add('d-none');
    document.body.classList.remove('pwa-prompt-open');
    let data = { pwaInfo: false, timestamp: new Date().getTime() };
    localStorage.setItem('pwa-info', JSON.stringify(data));
  });
}

export async function initSwitchLang() {
  document.querySelector('.language-select').addEventListener('input', (e) => {
    let lang = window.location.pathname.split('/')[1];
    var currentPath = window.location.pathname.replace('/' + lang, '');
    window.location.href = '/' + e.currentTarget.value + currentPath;
  });
}

export function initFooterLang() {
  let showLangBtn = document.querySelector('.js-show-footer-languages');
  showLangBtn.addEventListener('click', () => {
    let languagesList = document.querySelectorAll('.js-footer-languages li');
    for (let i = 0, len = languagesList.length; i < len; i++) {
      languagesList[i].classList.remove('d-none');
    }
    showLangBtn.remove();
  });
}

export async function initScrollLP() {
  const module = await import('../tools/basic-functions.js');
  module.click('.js-go-to-form', scrollLP);
}

export async function initBackButton() {
  document.querySelector('.js-back-button').addEventListener('click', (e) => {
    goBack(e);
  });
}

function switchUserNav(el) {
  if (!el.classList.contains('active')) {
    el.classList.add('active');
    document.querySelector('.js-panel-user').classList.add('active');
  } else {
    el.classList.remove('active');
    document.querySelector('.js-panel-user').classList.remove('active');
  }
}

function switchNav() {
  if (!document.body.classList.contains('nav-open')) {
    window['scrollTopAmount'] = window.pageYOffset;
    bodyLock();
  } else bodyUnlock();
  document.body.classList.toggle('nav-open');
  document.querySelector('.navigation').classList.toggle('active');
}

async function closeNav(el) {
  const moduleBasicFunc = await import('../tools/basic-functions.js');
  if (
    !document.querySelector('.navigation-wrapper').matches('.' + el.classList[0]) &&
    moduleBasicFunc.has(document.querySelectorAll('.navigation-wrapper'), '.' + el.classList[0]).length === 0
  ) {
    var navbarToggle = document.querySelector('.js-open-menu');
    moduleBasicFunc.simulateClick(navbarToggle);
  }
}

export function toggleFullScreen() {
  var doc = window.document;
  var docEl = doc.documentElement;

  var requestFullScreen =
    docEl.requestFullscreen || docEl.mozRequestFullScreen || docEl.webkitRequestFullScreen || docEl.msRequestFullscreen;
  var cancelFullScreen =
    doc.exitFullscreen || doc.mozCancelFullScreen || doc.webkitExitFullscreen || doc.msExitFullscreen;

  if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
    try {
      requestFullScreen?.call(docEl);
    } catch (e) {
      console.error(e);
    }
  } else {
    try {
      cancelFullScreen?.call(doc);
    } catch (e) {
      console.error(e);
    }
  }
}

function bodyLock() {
  if (bodyLockTimeout) clearTimeout(bodyLockTimeout);
  if (!document.body.classList.contains('body-lock')) {
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    document.body.classList.add('body-lock');
  }
}

function bodyUnlock() {
  if (bodyLockTimeout) clearTimeout(bodyLockTimeout);
  bodyLockTimeout = setTimeout(() => {
    if (document.body.classList.contains('body-lock')) {
      document.body.classList.remove('body-lock');
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    }
  }, 1000);
}

function goBack(e) {
  e.preventDefault();
  if (window.location.href.includes('/slots/') || window.location.href.includes('/slots/tag/')) {
    let langLocale = _CMS_LOCALE != '' ? _CMS_LOCALE : _CMS_LANGUAGE;
    window.location.href = window.location.origin + '/' + langLocale + '/casino-games';
  } else {
    window.location.href = window.location.href.substring(0, window.location.href.lastIndexOf('/'));
  }
}

export async function initResponsibleGamingLinks() {
  const moduleBasicFunc = await import('../tools/basic-functions.js');
  let linksList = document.querySelectorAll('.page-tnc .js-action.text-link');
  for (let i = 0, len = linksList.length; i < len; i++) {
    let link = linksList[i];
    link.addEventListener('click', (e) => {
      if (!document.body.classList.contains('js-loggedin')) {
        e.preventDefault();
        e.stopPropagation();
        moduleBasicFunc.simulateClick(document.querySelector('.btn-login'));
      }
    });
  }
}

export function initEnergyChestGameWindowPopup() {
  let energyChestNavBtn = document.querySelector('.js-cms-open-ecchest-popup'),
    ecChestPopup = document.querySelector('.js-cms-ecchest-popup');
  energyChestNavBtn.addEventListener('click', (e) => {
    document.querySelector('.js-cms-ecchest-popup .progressbar-bar-progress').style.width = document.querySelector(
      '.js-cms-ecchest-popup .js-progress'
    ).innerHTML;
    ecChestPopup.classList.toggle('active');
    e.currentTarget.classList.toggle('active');
  });
  document.addEventListener('click', (e) => {
    if (!ecChestPopup.contains(e.target) && ecChestPopup.classList.contains('active')) {
      ecChestPopup.classList.remove('active');
      energyChestNavBtn.classList.remove('active');
    }
    if (e.target == energyChestNavBtn) {
      document.querySelector('.js-cms-ecchest-popup .progressbar-bar-progress').style.width = document.querySelector(
        '.js-cms-ecchest-popup .js-progress'
      ).innerHTML;
      ecChestPopup.classList.add('active');
      energyChestNavBtn.classList.add('active');
    }
  });
}

async function scrollLP() {
  const module = await import('../tools/animations.js');
  var registrationForm = document.querySelector('.registration-form');
  module.slideDown(registrationForm);
  window.scrollTo({
    top: document.querySelector('.registration-form').offsetTop - 35,
    behavior: 'smooth'
  });
  return false;
}

export function initEnvPanel() {
  let hideEnvBtn = document.querySelector('.js-cms-hide-env-panel'),
    envPanel = document.querySelector('.dev-env-panel');
  hideEnvBtn.addEventListener('click', () => {
    if (hideEnvBtn.classList.contains('is-active')) {
      envPanel.classList.add('hide');
      hideEnvBtn.classList.remove('is-active');
    } else {
      envPanel.classList.remove('hide');
      hideEnvBtn.classList.add('is-active');
    }
  });
}

export function initMatchNavItems() {
  let checking = false;
  let checkingTimeout;
  const clearCheck = () => {
    if (checkingTimeout == null) return;
    clearTimeout(checkingTimeout);
    checkingTimeout = null;
  };
  const matchCheck = () => {
    if (checking) {
      clearCheck();
      checkingTimeout = setTimeout(matchCheck, 250);
      return;
    }
    checking = true;
    const navItemsWrapper = document.querySelector('nav ul.align-self-stretch');
    const navAdditionalWrapper = document.querySelector('nav .nav-additional-inner');
    const navAdditionalDotsWrapper = document.querySelector('nav .nav-additional-outer');
    const navAdditionalDots = document.querySelector('nav .nav-additional-outer .dots');
    if (navItemsWrapper && navAdditionalWrapper && navAdditionalDotsWrapper && navAdditionalDots) {
      while (navItemsWrapper.childElementCount > 0 && navItemsWrapper.scrollWidth > navItemsWrapper.offsetWidth) {
        const lastChild = navItemsWrapper.lastElementChild;
        lastChild.classList.add('moved');
        navAdditionalWrapper.insertBefore(lastChild, navAdditionalWrapper.firstChild);
      }
      while (
        document.querySelector('.nav-additional-inner .moved') &&
        document.querySelector('.nav-additional-inner .moved').offsetWidth + 15 <
          navAdditionalDotsWrapper.offsetWidth - navAdditionalDots.offsetWidth
      ) {
        const navAdditionalChild = document.querySelector('.nav-additional-inner .moved');
        navAdditionalChild.classList.remove('moved');
        navItemsWrapper.appendChild(navAdditionalChild);
      }
    }
    setTimeout(() => {
      checking = false;
    }, 200);
  };
  window.addEventListener('resize', matchCheck);
}
